module.exports = __webpack_public_path__ + "img/schmiedeeisen.946b0cb3.jpg";